import React, { useEffect, useState } from "react";
import { Viewer, Worker } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import "react-pdf/dist/esm/Page/TextLayer.css";

const CheckType = ({
  url,
  attachmentName,
}: {
  url: any;
  attachmentName: string;
}) => {
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);

  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  useEffect(() => {
    if (attachmentName.includes(".pdf")) {
      if (url instanceof Blob || url instanceof File) {
        const blobUrl = URL.createObjectURL(url);
        setPdfUrl(blobUrl);
      } else if (typeof url === "string") {
        setPdfUrl(url);
      }
    }
  }, [url, attachmentName]);

  // audio //
  if (
    attachmentName.includes(".mp3") ||
    attachmentName.includes(".wav") ||
    attachmentName.includes(".ogg")
  ) {
    return (
      <div className={"h-60px d-flex flex-column justify-content-center"}>
        <audio controls>
          <source src={url} type="audio/wav" />
          Your browser not able to support audio.
        </audio>
      </div>
    );
  }

  // video //
  if (attachmentName.includes(".mp4")) {
    return (
      <div className={"h-600px"}>
        <video width="100%" height="100%" controls>
          <source src={url} type="video/mp4" />
          Your browser not able to support video.
        </video>
      </div>
    );
  }

  // image //
  if (
    attachmentName.includes(".png") ||
    attachmentName.includes(".jpg") ||
    attachmentName.includes(".jpeg") ||
    attachmentName.includes(".gif")
  ) {
    return (
      <div className={"h-600px"}>
        <img
          src={url}
          alt="Media content"
          className={"max-w-100 w-100 max-h-100 h-100"}
          style={{ objectFit: "contain" }}
        />
      </div>
    );
  }

  // docx & xlsx //
  if (
    attachmentName.includes(".doc") ||
    attachmentName.includes(".docx") ||
    attachmentName.includes(".xls") ||
    attachmentName.includes(".xlsx")
  ) {
    return <div>برای مشاهده فایل آن را دانلود کنید...</div>;
  }

  // PDF loading
  if (!pdfUrl) return <div>Loading...</div>;

  // PDF //
  if (attachmentName.includes(".pdf")) {
    return (
      <div className={"h-600px w-100"}>
        <Worker
          workerUrl={`https://unpkg.com/pdfjs-dist@2.10.377/build/pdf.worker.min.js`}
        >
          <Viewer fileUrl={pdfUrl} plugins={[defaultLayoutPluginInstance]} />
        </Worker>
      </div>
    );
  }

  return <div>Unsupported format</div>;
};

export default CheckType;
